function getDays () {
  let data = [{ text: 'dag', value: '' }]
  for (let i = 1; i <= 31; i++) {
    data.push(i)
  }
  return data
}

function getMonths () {
  let data = [
    { text: 'maand', value: '' },
    { text: 'januari', value: 1 },
    { text: 'februari', value: 2 },
    { text: 'maart', value: 3 },
    { text: 'april', value: 4 },
    { text: 'mei', value: 5 },
    { text: 'juni', value: 6 },
    { text: 'juli', value: 7 },
    { text: 'augustus', value: 8 },
    { text: 'september', value: 9 },
    { text: 'oktober', value: 10 },
    { text: 'november', value: 11 },
    { text: 'december', value: 12 },
  ]
  return data
}

function getMonthAsString (month) {
  let months = getMonths()
  return months[month].text
}

function getYears (minAge, count) {
  let data = [{ text: 'jaar', value: '' }]
  let curYear = new Date().getFullYear()
  let endYear = (curYear - minAge)
  let startYear = endYear - count
  for (let i = endYear; i >= startYear; i--) {
    data.push(i)
  }
  return data
}

function dutchDate (date) {
  if(date.length !== 10){
    return ''
  }
  let months = getMonths()

  date = date.split('-')
  let month = parseInt(date[1])

  return `${date[2]} ${months[month].text} ${date[0]}`
}

export {
  getDays,
  getMonths,
  getYears,
  getMonthAsString,
  dutchDate
}